<template>
  <div>
    <!-- 联系区域 -->
    <div class="connect-area" v-if="!hideConnect">
      <ul class="connect">
        <li class="connect-item">
          <p class="title">{{ $t('联系电话') }}</p>
          <p
            class="text"
            style="text-align: left;">
            +86 400-022-9291（{{ $t('中国大陆') }}）
          </p>
          <p
            class="text"
            style="text-align: left;">
            +1 939-332-7285（{{ $t('美国地区') }}）
          </p>
        </li>
        <li
          class="connect-item"
          style="margin: 0 132px 0 99px;">
          <p class="title">{{ $t('联系地址') }}</p>
          <p class="text">ST 330, 270 Muñoz Rivera Ave, San Juan, Puerto Rico, United States 00918</p>
        </li>
        <li class="connect-item">
          <p class="title">{{ $t('联系邮箱') }}</p>
          <p class="text">support@cbibank.com</p>
        </li>
      </ul>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <span>CB International Bank {{ $t('版权所有') }} Copyright@2022</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hideConnect: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.connect-area {
  height: 110px;
  background: #2c2c86;
  padding-top: 20px;
  .connect {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin: 0 auto;
    .connect-item {
      text-align: center;
      .title {
        height: 14px;
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #6a76a9;
        line-height: 14px;
      }
      .text {
        max-width: 388px;
        font-size: 14px;
        font-weight: 500;
        color: @white;
        line-height: 20px;
      }
    }
  }
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #101533;
  > span {
    font-size: 12px;
    font-weight: 400;
    color: #5563b9;
  }
}
</style>
